import React from "react";
import HomePage from "pages/home";
import Pc from "pages/pc";
import InformationPage from "pages/information";
import VoucherPage from "pages/voucher";
import GuidePage from "pages/guide";

const routesCampaign = [
  {
    path: "/" || "/#guide" || "/#joinNow",
    name: "Trang chủ",
    element: <HomePage />,
  },

  // {
  //   path: "/danhsachtrungthuong",
  //   name: "Danh sách trúng thưởng",
  //   element: <PrizePage />,
  // },
  // {
  //   path: "/thelechuongtrinh",
  //   name: "Thể lệ chương trình",
  //   element: <RulesPage />,
  // },
  {
    path: "/voucher",
    name: "voucher",
    element: <VoucherPage />,
  },
  {
    path: "/information",
    name: "Thông tin người dùng trúng thưởng",
    element: <InformationPage />,
  },
  {
    path: "/guide",
    name: "guide",
    element: <GuidePage />,
  },
  {
    path: "/*",
    name: "guide",
    element: <GuidePage />,
  },
  {
    path: "/pc",
    name: "",
    element: <Pc />,
  },
];

export default routesCampaign;
